import { Component, NgZone, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { AlertController, MenuController, ModalController, NavController, Platform } from '@ionic/angular';
import { GlobalVariable } from '../global';
import { OpenReviewPage } from '../open-review/open-review.page';
import { ServerService } from '../providers/server.service';
import { ShowUserReviewsPage } from '../show-user-reviews/show-user-reviews.page';
declare var google;
@Component({
  selector: 'app-landing',
  templateUrl: './landing.page.html',
  styleUrls: ['./landing.page.scss'],
})
export class LandingPage implements OnInit {
  autocompleteItems: any;
  autocomplete: any;
  service = new google.maps.places.AutocompleteService();
  items = [];
  startFinding = false;
  socialLinks=[
    {
      name:'Facebook',
      icon:'logo-facebook',
      link:'https://www.facebook.com/groups/864869013856025'
    },
    {
      name:'TikTok',
      icon: 'logo-tiktok',
      link:'https://www.tiktok.com/@thehalalguide?lang=en'
    },
    {
      name:'Instagram',
      icon: 'logo-instagram',
      link:'https://www.instagram.com/thehalalguide_/'
    }
  ]
  slides = {
    slidesPerView: 1,
  allowTouchMove: false ,

    // autoplay: true,
    // loop: true,
    // speed: 2000,

    // fadeEffect: {
    //   crossFade: true
    // },
  };
  isLoggedIn: string;
  temp: boolean = false;
  geo: any;
  addressSearch: boolean = false;
  WEBPlatform: boolean = false;
  dataNotLoaded: boolean = true;
  reviews = [];
androidLink="https://play.google.com/store/apps/details?id=net.thehalalguide.app";
iosLink="https://apps.apple.com/us/app/the-halal-guide/id1580519395";
  showDownload: boolean=false;
  currentYear:any;
  constructor(
    private nav: NavController,
    private geoLocation: Geolocation,
    public globals: GlobalVariable,
    public zone: NgZone,
    public server: ServerService,
    public router: Router,
    public modalCtrl: ModalController,
    public menuCtrl: MenuController,
    public platform:Platform,
    public aib:InAppBrowser,
    public alertController:AlertController,
  ) {
    this.currentYear = new Date().getFullYear();
    let currentUrl = window.location.hostname;
    if (this.globals.webURL == currentUrl) {
      this.WEBPlatform = true;
      console.log(currentUrl);
    } else {
      this.WEBPlatform = false;
    }

    this.autocompleteItems = [];
    this.autocomplete = {
      query: '',
    };
    this.loadReviews();
    this.isLoggedIn = localStorage.getItem('isLogin');
    // this.getlocation()
  }

  ngOnInit() {}
  ionViewWillEnter() {
    let width=window.innerWidth;
    console.log(width)
    if(width<1200){
      console.log(true)
      this.showDownload=true;
    }
    if (!this.globals.address) {
      this.getLocation();
    }
  }
android(){
  this.aib.create(this.androidLink)
}
facebook(){
  // window.open(this.socialLinks[0].link, '_blank').focus();

  this.aib.create(this.socialLinks[0].link,'_system')

}
tiktok(){
  // window.open(this.socialLinks[1].link, '_blank').focus();

  this.aib.create(this.socialLinks[1].link,'_system');

}
insta(){
  this.aib.create(this.socialLinks[2].link,'_system');
  // window.open(this.socialLinks[2].link, '_blank').focus();


}
loadLink(link){
  this.aib.create(link,'_blank');

}

ios(){
  this.aib.create(this.iosLink)

}
  home() {
    // this.router.navigateByUrl('/home', {replaceUrl: true})
    this.nav.navigateRoot('/home');
  }
  ionViewDidEnter() {
    this.globals.checkGPSPermission();

    // this.loadReviews();
  }
  openMenu() {
    // this.menuCtrl.swipeGesture(false,'001');
    this.menuCtrl.open('001');
  }
  login() {
    this.nav.navigateForward('login');
  }
  signup() {
    this.nav.navigateForward('signup');
  }
  profile() {
    this.nav.navigateForward('settings');
  }
  privacy() {
    this.nav.navigateForward('terms-privacy');
  }
  about() {
    this.nav.navigateForward('about-us');
  }
  blogs() {
    this.nav.navigateForward('blogs');
  }
  // getlocation(){
  //   this.geoLocation.getCurrentPosition().then(res=>{
  //     console.log(res)
  //   },err=>{

  //   })
  // }
  async openReview(review) {
    console.log(review);
    const modal = await this.modalCtrl.create({
      component: OpenReviewPage,
      componentProps: { review: review },
      cssClass: 'reviewmodal',
      // breakpoints:[0,0.6,0.8,1],
      // initialBreakpoint:0.6,
      // handle:false,
    });
    modal.present();
  }
  navigate(review) {
    let name = review.business_name + '-' + review.business_address;
    // console.log(business.name,business.address)
    name = name.replace(/[^a-zA-Z ]/g, '');
    name = name.replace(/ /g, '-');
    name = name.replace(/--/g, '-');
    // value=value.replace(/,/g,'')
    this.router.navigateByUrl('' + name + '/' + review.business_id, {
      state: { businessData: {}, uniqueid: review.business_id },
    });
  }
  loadReviews() {
    // this.dataNotLoaded=false;
    this.server.recentReviews().subscribe(
      (res) => {
        this.dataNotLoaded = false;
        console.log(res);
        if (res.success == true) {
          let revs = res.reviews;
          revs.forEach((review) => {
            review.color = this.getColors();
          });
          this.reviews = revs;
          console.log('length is ', this.reviews.length, this.reviews);

          // this.reviews
        }

        // console.log(res)
      },
      (err) => {
        this.globals.presentToast('Network error.');
        // this.reviews=[];
        // this.dataNotLoaded=false;
      }
    );
  }
  async openUsersReviews(review) {
    let modal = await this.modalCtrl.create({
      component: ShowUserReviewsPage,
      componentProps: { data: { user: review } },
    });
    modal.onDidDismiss().then((data) => {
      console.log(data);
      if (data != null || data != undefined) {
      }
      console.log('usermodal says.=> ', data);
    });
    modal.present();
  }
  getColors() {
    let symbols = '0123456789ABCDEF';

    let color = '#';
    for (var i = 0; i < 6; i++) {
      color = color + symbols[Math.floor(Math.random() * 16)];
    }
    return color;
  }
  saveAddress() {
    // this.globals.address = this.autocomplete.query;
    this.addressSearch = false;
    this.autocompleteItems = [];
    // this.globals.dataNotLoaded=true;
    // this.resList=[];
    // this.hasData=true;
    // this.offset=0;
    // this.limit=20;
    // this.list();
  }
  editAddress() {
    this.addressSearch = true;
  }
  dismiss() {
    this.temp = false;
    this.addressSearch = false;
    this.autocompleteItems = [];
    this.autocomplete = {
      query: '',
    };
  }
  // loadBanner() {
  //   let response = this.server.LoadBannersOnHomePage();
  //   response.subscribe((data) => {
  //     console.log(data);
  //   });
  // }

  cancelAddressSearch() {
    this.addressSearch = false;
  }
  find() {
    this.startFinding = true;
  }
  chooseItem(item: any) {
    if (item == undefined || item == null) {
      this.globals.presentToast('Invalid address!');
      return;
    }
    this.autocomplete.query = item;
    this.geo = item;
    this.globals.address = this.autocomplete.query;
    this.addressSearch = false;
    this.autocompleteItems = [];
    // this.globals.dataNotLoaded=true;
    // this.resList=[];
    // this.hasData=true;
    // this.offset=0;
    // this.limit=20;
    // this.list();
    // this.dismiss();
    this.geoCode(this.geo);
    console.log('item', item);
    console.log('geo', this.geo);
  }
  geoCode(address: any) {
    // let that = this;
    let geocoder = new google.maps.Geocoder();
    geocoder.geocode({ address: address }, (results, status) => {
      console.log('results ', results);
      this.globals.mycoordinates =
        results[0].geometry.location.lat() +
        ',' +
        results[0].geometry.location.lng();
      // new added
      this.nav.navigateRoot('home');
      // new added
    });
  }
  updateSearch() {
    // console.log("search is on");
    // console.log(this.autocompleteItems);
    // console.log("length", this.autocomplete.query.length);

    if (this.autocomplete.query == '') {
      console.log('if run');
      this.autocompleteItems = [];
      this.temp = false;
      return;
    } else if (this.autocomplete.query.length >= 3) {
      console.log('else if run');
      this.temp = true;
      let me = this;
      this.service.getPlacePredictions(
        {
          input: this.autocomplete.query,
          types: ['address'],
          componentRestrictions: {
            country: ["us", "ca"],
          },
        },
        (predictions, status) => {
          me.autocompleteItems = [];

          me.zone.run(() => {
            if (predictions != null) {
              // console.log(predictions)
              predictions.forEach((prediction) => {
                me.autocompleteItems.push(prediction.description);
                // console.log(me.autocompleteItems);
              });
            }
          });
        }
      );
    } else {
      console.log('else run');
    }
  }
  getLocation() {
    this.globals.presentToast('Getting location...');
    this.geoLocation.getCurrentPosition().then(
      (position) => {
        // this.addressSearch = false;
        this.globals.mycoordinates =
          position.coords.latitude + ',' + position.coords.longitude;
        this.reverseGeoCoding();
      },
      async (err) => {
        // if(this.globals.inWeb){
        // this.locationAlert()

        // }
        console.log('user deny location',err);
        this.globals.presentToast("You've blocked the location, please enable it",4000,'middle');
      }
    );
  }
  reverseGeoCoding() {
    let response = this.server.getAddress(this.globals.mycoordinates);
    var myadress = '';
    response.subscribe(
      (data) => {
        // console.log('data from adrress api ',data);
        myadress = data.address;
        this.globals.address = myadress;
      },
      (error) => {
        this.globals.presentToast('Please Turn on your location.');
      }
    );
  }

  async locationAlert() {
    const options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0
    };
    const alert = await this.alertController.create({
      header: 'Warning!',
      mode:'ios',
      message: "You've blocked the location or failed to get location. please enable location to continue using The Halal Guide",
      buttons: [
        {
          text: 'Enable now',
          handler: () => {
            console.log('Confirm Okay');
      navigator.geolocation.getCurrentPosition(locationSuccess=>{
  console.log('Your current position is:',locationSuccess);
  this.getLocation();

}, locationError=>{
  console.warn(`ERROR(${locationError.code}): ${locationError.message}`);
  // this.globals.presentToast('')
  // this.locationAlert()


},options);


          }
        }
      ],
      backdropDismiss:false,
    });
  
    await alert.present();
  }


}

// import {Observable} from 'Rxjs/rx';

// ionViewDidEnter() {
//   ...... //you get slider data from any web service
//   this.sliderObservable = Observable.interval(3000).subscribe(x => {
//         this.autoPlaySlider();
//    });
// }
// autoPlaySlider(){
//     var slider_index = this.slides.getActiveIndex();
//     if(slider_index < this.sliderData.length){
//         this.slides.slideTo(slider_index+1);
//     }
//     else{
//         this.slides.slideTo(0);
//     }
//   }
// ionViewDidLeave(){
//     this.sliderObservable.unsubscribe();
// }
